import "core-js/modules/es.function.name";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import AvatarPreview from '../AvatarPreview';
import withThemeProps from '../withThemeProps';
import useTextToMaterialColor from '../useTextToMaterialColor';
import useHumanInitiales from './useHumanInitiales';

function HumanAvatar(_ref) {
  var human = _ref.human,
      rest = _objectWithoutProperties(_ref, ["human"]);

  var avatar = human.avatar,
      name = human.name;
  var initials = useHumanInitiales(human);
  var avatarBgColor = useTextToMaterialColor(name);
  return React.createElement(AvatarPreview, _extends({}, rest, {
    bgColor: avatarBgColor,
    imageSrc: avatar,
    label: initials
  }));
}

HumanAvatar.propTypes = {
  /**
   * Objekt s informacemi o cloveku.
   */
  human: PropTypes.shape({
    /**
     * URL adresa image s avatarem.
     */
    avatar: PropTypes.string,

    /**
     * Jmeno
     */
    firstName: PropTypes.string,

    /**
     * Prijmeni
     */
    lastName: PropTypes.string,

    /**
     * Prostredni jmeno
     */
    middleName: PropTypes.string,

    /**
     * Cele jmeno zobrazuje se vedle avatara
     */
    name: PropTypes.string.isRequired
  }).isRequired,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * Velikost avataru. Muze byt jedena z variant odpovidajici velikostem
   *
   * - 'small' 24px
   * - 'normal' 40px
   * - 'large' 56px
   *
   * nebo vlatni velikost v px.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(['normal', 'small', 'large']), PropTypes.number])
};
HumanAvatar.defaultProps = {
  margin: 'none',
  size: 'normal'
};
export default withThemeProps({
  name: 'SxHumanAvatar'
})(HumanAvatar);